<template>
    <div>
        <change-password :model="editPassword" @close="passwordChanged()" @cancel="editPassword = false" />


        <v-container>
            <h1>
                <v-icon left size="30">mdi-account</v-icon>
                My Account
            </h1>
            <v-row>
                <v-col cols="4">
                    <v-card>
                        <v-card-title class="title">{{ displayName || "&lt;not specified&gt;" }}</v-card-title>
                        <v-card-text>{{ email }}</v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <v-btn text disabled>Edit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card>
                        <v-card-title class="title">Password</v-card-title>
                        <v-card-text>*****************</v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <v-btn text @click="changePassword()">Change password</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import store from "@/services/store";
import toast from "@/services/toast";
import ChangePassword from "./ChangePassword.vue";

export default {
    data: () => ({
        editPassword: false,
    }),
    methods: {
        changePassword() {
            this.editPassword = true;
        },
        passwordChanged() {
            toast(`Your password was changed.`);

            this.editPassword = false;
        },
    },
    computed: {
        displayName: () => store.state.id.displayName,
        email: () => store.state.id.email
    },
    components: { ChangePassword }
};
</script>
